import { render, staticRenderFns } from "./MagazzinoArticoliViewComponent.vue?vue&type=template&id=53ab0a7c"
import script from "./MagazzinoArticoliViewComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports